import React, { useEffect } from "react";
import { Button, Dropdown, Menu, Tooltip } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { useSaleOrderModel } from "../saleOrderModel";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { useSaleOrderDetailModel } from "./details/saleOrderDetailModel";
import { DownOutlined } from "@ant-design/icons";
import useGlobalModel from "@/model/globalModel";
import { formatNum } from "@/utils/utils";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { disableExportMsg } from "@/utils/exportFile";

export const DataBox = () => {
    const { selectedRowKeys, selectedRow, descTotal, rowsDescTotal, setSettleScaniaPrint, setPrint, detailsExport, onInvalidate, exportSaleOrder, setSelectedRowKeys } = useSaleOrderModel();
    const {
        resetEditCatch,
    } = useSaleOrderDetailModel();
    const { selectedNavId, addNav, findNav, selectNav, switchNavState, replaceNav } = useNavModel();
    const { shopAndOrg: { shopCode } } = useGlobalModel()

    const desc: IDescription[] = [
        {
            label: "订单数量",
            value: selectedRowKeys.length === 0 ? descTotal.totalNum : rowsDescTotal.totalNum,
            color: DescriptionColorEnum.red
        },
        {
            label: "订单总金额",
            value: formatNum(selectedRowKeys.length === 0 ? descTotal.totalAmount : rowsDescTotal.totalAmount),
            color: DescriptionColorEnum.red
        }
    ]
    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        if (selectedRow.status === "sale-order.change") {
            globalPrompt("message", { text: "该单据已作废，无法进行编辑", type: "warning" });
            return;
        }
        let saleOrderEditKey = "5-1-2";
        let isFindNav = findNav(saleOrderEditKey);
        if (!isFindNav) {
            addNav(saleOrderEditKey, { id: selectedRow?.saleOrderCode as string, mode: "edit" });
        } else {
            globalPrompt("modal", {
                title: "销售订单跳转详情",
                type: "warning",
                text: "您还有销售订单详情未保存，是否跳转",
                okText: "跳转未保存页",
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                cancelText: "打开新页签",
                onCancel: () => {
                    switchNavState(saleOrderEditKey, { id: selectedRow?.saleOrderCode as string, mode: "edit" });
                    resetEditCatch();
                }
            })
        }
    }
    const onLook = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        let supplierEditKey = "5-1-3";
        replaceNav(
            selectedNavId,
            supplierEditKey,
            { id: selectedRow?.saleOrderCode as string, mode: "look", },
            true
        );
    }
    const exportMenu = () => {
        return (
            <Menu>
                <Menu.Item key="0">
                    <span onClick={() => exportSaleOrder()}>列表导出</span>
                </Menu.Item>
                <Menu.Item key="1">
                    <span onClick={() => detailsExport()}>详情导出</span>
                </Menu.Item>
            </Menu>
        )
    }
    const onSettleSknyPrint = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        setSettleScaniaPrint(true)
    }
    const onPrint = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        setPrint(true)
    }
    const action = <>
        <YhAuth resCode={ResourceAuthEnum.S_SO_AD}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => addNav('5-1-1', { id: "", mode: "add" })}
            >新增</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.S_SO_ED}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onEdit}
            >编辑</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.S_SO_VW}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onLook}
            >查看</Button>
        </YhAuth>
        {/* {shopCode === "SHOP-M-00000020" ||
            shopCode === "SHOP-M-00000019" ||
            shopCode === "SHOP-M-00000021" ?
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onSettleSknyPrint}
            >结算打印</Button> :
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onPrint}
            >打印</Button>
        } */}
        {/* <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={onPrint}
        >财务打印</Button> */}
        <YhAuth resCode={ResourceAuthEnum.S_SO_CANCEL}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => {
                    if (selectedRowKeys.length !== 1) {
                        globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
                        return;
                    }
                    onInvalidate()
                }}
            >作废</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.S_SO_EX}>
            {/* <Tooltip placement="topLeft" title={disableExportMsg}> */}
            <Dropdown overlay={exportMenu}>
                <Button
                    // disabled={true}
                    className="mr-5"
                    type="primary"
                    shape="round"
                >导出<DownOutlined /></Button>
            </Dropdown>
            {/* </Tooltip> */}

        </YhAuth>
        {/* <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={() => exportSaleOrder().then()}
        >导出</Button> */}
    </>;

    return (
        // <YhBox title={"销售订单列表"} descriptions={desc} action={action} style={{height:'calc(100vh - 200px)'}}>
        <YhBox action={action} style={{ height: 'calc(100vh - 180px)' }}>
            <DataTable />
        </YhBox>
    )
}